import { render, staticRenderFns } from "./editEvents.vue?vue&type=template&id=592cbe84&scoped=true&"
import script from "./editEvents.vue?vue&type=script&lang=js&"
export * from "./editEvents.vue?vue&type=script&lang=js&"
import style0 from "./editEvents.vue?vue&type=style&index=0&id=592cbe84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592cbe84",
  null
  
)

export default component.exports